import './style.scss';

const { store, ActionCreators, EventTypes } = window.__app__;

async function onLocationChanged()
{
	try
	{
		const actionName = 'redsign:devfunc.controller.location.setLocation';
		const actionData = { data: { locationId: store.state.location.id } };
		const result = await new Promise((resolve, reject) => {
			BX.ajax.runAction(actionName, actionData)
				.then(resolve, reject);
		});
		
		if (result.status === 'success')
		{
			if (!__app__.store.state.location.confirmed)
				store.dispatch(ActionCreators.confirmLocation());
				
			const resultData = result.data;
			if (resultData.redirect)
				window.location.href = resultData.redirect;
			else
				BX.reload();
		}
		else
		{
			console.error('can\'t change location');
		}
	}
	catch(e)
	{
		console.error(e);
	}
}


store.subscribe(EventTypes.LOCATION_CHANGED, onLocationChanged);